import HttpException from './HttpException';

export default class BadRequestHttpException extends HttpException {
    name = 'BadRequestHttpException';

    constructor(response: Response, message?: string) {
        super(response, message ?? 'Exceptions.services.http.bad_request');
    }
}
